/* Byteful · premium hareketler: kreatif vitrin, telefon sahnesi, bildirimler, büyüme paneli */
(function () {
  'use strict';

  if (window.__bdMotion) return;
  window.__bdMotion = true;

  var root = document.documentElement;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var small = window.matchMedia('(max-width: 749px)');

  function motionOK() {
    return !reduced.matches && !root.classList.contains('bd-motion-off');
  }
  function saveData() {
    var c = navigator.connection;
    return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || '')));
  }
  function autoplayOK() {
    return motionOK() && !saveData();
  }
  function define(name, ctor) {
    if (!window.customElements.get(name)) window.customElements.define(name, ctor);
  }
  function track(name, data) {
    var payload = data || {};
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, payload);
      }
    } catch (error) { /* analitik isteğe bağlıdır */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload));
    } catch (error) { /* yok say */ }
  }

  /* ---------------------------------------------------------------
     Video yardımcıları
     --------------------------------------------------------------- */
  function loadVideo(video, hd) {
    if (!video) return false;
    var src = hd ? (video.dataset.srcHd || video.dataset.src) : (video.dataset.src || video.dataset.srcHd);
    if (!src) return false;
    if (video.dataset.loaded !== src) {
      video.src = src;
      video.dataset.loaded = src;
    }
    return true;
  }
  function safePlay(video) {
    try {
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') promise.catch(function () {});
    } catch (error) { /* oynatılamadı */ }
  }

  /* ---------------------------------------------------------------
     Kaydırma ilerleme çizgisi
     --------------------------------------------------------------- */
  var progress = document.querySelector('.bd-progress');
  if (progress) {
    var ticking = false;
    var updateProgress = function () {
      ticking = false;
      var max = root.scrollHeight - window.innerHeight;
      progress.style.setProperty('--p', max > 0 ? Math.min(1, window.scrollY / max).toFixed(4) : '0');
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });
    window.addEventListener('resize', updateProgress, { passive: true });
    updateProgress();
  }

  /* ---------------------------------------------------------------
     Kartlarda fareyi izleyen ışık
     --------------------------------------------------------------- */
  document.addEventListener('pointermove', function (event) {
    if (event.pointerType !== 'mouse' || !event.target.closest) return;
    var el = event.target.closest('[data-spotlight]');
    if (!el) return;
    var rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', (event.clientX - rect.left).toFixed(0) + 'px');
    el.style.setProperty('--my', (event.clientY - rect.top).toFixed(0) + 'px');
  }, { passive: true });

  /* ---------------------------------------------------------------
     Mıknatıs etkili ana butonlar (yalnızca fare ile)
     --------------------------------------------------------------- */
  function magnetic(button) {
    if (button.dataset.magnetic) return;
    button.dataset.magnetic = '1';
    var rect = null;
    button.addEventListener('pointerenter', function () { rect = button.getBoundingClientRect(); });
    button.addEventListener('pointermove', function (event) {
      if (!rect || event.pointerType !== 'mouse' || !motionOK()) return;
      var x = (event.clientX - rect.left - rect.width / 2) * 0.14;
      var y = (event.clientY - rect.top - rect.height / 2) * 0.26;
      button.style.transform = 'translate(' + x.toFixed(1) + 'px, ' + y.toFixed(1) + 'px)';
    });
    button.addEventListener('pointerleave', function () {
      rect = null;
      button.style.transform = '';
    });
  }
  function initMagnetic(scope) {
    if (!finePointer.matches) return;
    (scope || document).querySelectorAll('.bd-btn--accent').forEach(magnetic);
  }

  /* ---------------------------------------------------------------
     Telefon sahnesi: reklam videoları sırayla oynar
     --------------------------------------------------------------- */
  class BdPhoneFeed extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('.bd-phone__slide'));
      this.bars = Array.prototype.slice.call(this.querySelectorAll('.bd-phone__bars i'));
      this.brand = this.querySelector('[data-phone-brand]');
      this.interval = parseFloat(this.dataset.interval) || 7000;
      this.index = 0;
      this.remaining = 0;
      this.style.setProperty('--dur', this.interval + 'ms');
      if (!this.slides.length) return;
      if (!autoplayOK() || !('IntersectionObserver' in window)) {
        this.classList.add('is-static');
        return;
      }
      this.io = new IntersectionObserver(function (entries) {
        this.visible = entries[0].isIntersecting;
        if (this.visible && !document.hidden) this.play();
        else this.pause();
      }.bind(this), { threshold: 0.2 });
      this.io.observe(this);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) this.pause();
        else if (this.visible) this.play();
      }.bind(this));
    }

    videoAt(i) {
      return this.slides[i] ? this.slides[i].querySelector('video') : null;
    }

    setBars() {
      this.bars.forEach(function (bar, n) {
        bar.classList.toggle('is-done', n < this.index);
        if (n === this.index) {
          if (!bar.classList.contains('is-active')) {
            void bar.offsetWidth;
            bar.classList.add('is-active');
          }
        } else {
          bar.classList.remove('is-active');
        }
      }.bind(this));
    }

    play() {
      if (this.playing) return;
      this.playing = true;
      var video = this.videoAt(this.index);
      if (loadVideo(video, false)) safePlay(video);
      this.slides[this.index].classList.add('is-active');
      this.setBars();
      this.classList.remove('is-paused');
      window.clearTimeout(this.timer);
      this.startedAt = performance.now();
      var wait = this.remaining || this.interval;
      this.timer = window.setTimeout(this.next.bind(this), wait);
      this.remaining = 0;
      var nextVideo = this.videoAt((this.index + 1) % this.slides.length);
      if (nextVideo && nextVideo !== video) {
        window.clearTimeout(this.preloadTimer);
        this.preloadTimer = window.setTimeout(function () {
          if (loadVideo(nextVideo, false)) nextVideo.preload = 'auto';
        }, Math.max(0, wait - 2500));
      }
    }

    pause() {
      if (!this.playing) return;
      this.playing = false;
      window.clearTimeout(this.timer);
      window.clearTimeout(this.preloadTimer);
      if (this.startedAt) this.remaining = Math.max(900, this.interval - (performance.now() - this.startedAt));
      var video = this.videoAt(this.index);
      if (video) video.pause();
      this.classList.add('is-paused');
    }

    next() {
      var prev = this.index;
      var prevSlide = this.slides[prev];
      var prevVideo = this.videoAt(prev);
      this.index = (this.index + 1) % this.slides.length;
      if (this.index === 0) this.bars.forEach(function (bar) { bar.classList.remove('is-done', 'is-active'); });
      prevSlide.classList.remove('is-active');
      prevSlide.classList.add('is-leaving');
      window.setTimeout(function () {
        prevSlide.classList.remove('is-leaving');
        if (prevVideo && !prevSlide.classList.contains('is-active')) {
          prevVideo.pause();
          try { prevVideo.currentTime = 0; } catch (error) { /* yok say */ }
        }
      }, 900);
      var name = this.slides[this.index].dataset.brand;
      if (this.brand && name) this.brand.textContent = name;
      this.playing = false;
      this.remaining = 0;
      this.play();
    }
  }

  /* ---------------------------------------------------------------
     Bildirim yığını: kartlar yukarıdan gelir, eskiler aşağıda solar
     --------------------------------------------------------------- */
  class BdNotifyStack extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.items = Array.prototype.slice.call(this.querySelectorAll('.bd-note'));
      if (!this.items.length) return;
      this.visibleCount = parseInt(this.dataset.visible, 10) || (small.matches ? 2 : 3);
      this.liveTime = this.dataset.liveTime !== 'false';
      this.timeLabels = ['şimdi', '1 dk önce', '3 dk önce', '6 dk önce', '9 dk önce'];
      this.interval = parseFloat(this.dataset.interval) || 2600;
      this.shown = [];
      this.cursor = 0;
      this.classList.add('is-ready');
      this.items.forEach(function (el) { el.classList.add('is-queued'); });

      if (!motionOK() || !('IntersectionObserver' in window)) {
        for (var i = 0; i < Math.min(this.visibleCount, this.items.length); i++) this.push(true);
        return;
      }
      this.push(true);
      this.io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) this.start();
        else this.stop();
      }.bind(this), { threshold: 0.15 });
      this.io.observe(this);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) this.stop();
      }.bind(this));
      window.addEventListener('resize', function () { this.layout(); }.bind(this), { passive: true });
    }

    start() {
      if (this.running) return;
      this.running = true;
      this.timer = window.setInterval(function () { this.push(false); }.bind(this), this.interval);
    }

    stop() {
      this.running = false;
      window.clearInterval(this.timer);
    }

    push(instant) {
      var el = this.items[this.cursor % this.items.length];
      this.cursor += 1;
      var existing = this.shown.indexOf(el);
      if (existing > -1) this.shown.splice(existing, 1);
      el.classList.remove('is-queued', 'is-leaving');
      if (!instant) {
        el.classList.add('is-entering', 'is-new');
        void el.offsetWidth;
        window.clearTimeout(el._newTimer);
        el._newTimer = window.setTimeout(function () { el.classList.remove('is-new'); }, 1000);
      }
      this.shown.unshift(el);
      el.classList.remove('is-entering');
      if (this.shown.length > this.visibleCount) {
        var old = this.shown.pop();
        old.classList.add('is-leaving');
        window.setTimeout(function () {
          if (this.shown.indexOf(old) === -1) {
            old.classList.remove('is-leaving');
            old.classList.add('is-queued');
          }
        }.bind(this), 700);
      }
      this.layout();
    }

    layout() {
      var y = 0;
      var labels = this.timeLabels;
      var live = this.liveTime;
      this.shown.forEach(function (el, i) {
        if (live) {
          var t = el.querySelector('.bd-note__meta i');
          if (t) t.textContent = labels[Math.min(i, labels.length - 1)];
        }
        el.style.setProperty('--i', i);
        el.style.setProperty('--y', y + 'px');
        y += el.offsetHeight + 10;
      });
      this.style.setProperty('--stack-h', Math.max(0, y - 10) + 'px');
    }
  }

  /* ---------------------------------------------------------------
     Kreatif vitrin: görünen videolar sessiz oynar, dokununca sesli izlenir
     --------------------------------------------------------------- */
  class BdReels extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.section = this.closest('.bd-reels') || this.parentElement;
      this.list = this.querySelector('[data-reel-list]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('.bd-reel'));
      this.maxPlay = parseInt(this.dataset.maxPlay, 10) || 2;
      if (small.matches) this.maxPlay = 1;
      this.autoplay = this.dataset.autoplay !== 'false' && autoplayOK();
      this.ratios = new Map();
      this.lightbox = this.section.querySelector('[data-lightbox]');
      this.filters = Array.prototype.slice.call(this.section.querySelectorAll('[data-reel-filter]'));
      this.prevBtn = this.section.querySelector('[data-reel-prev]');
      this.nextBtn = this.section.querySelector('[data-reel-next]');

      this.cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        video.addEventListener('playing', function () { card.classList.add('is-playing'); });
        video.addEventListener('pause', function () { card.classList.remove('is-playing'); });
      });

      this.endTile = this.querySelector('[data-reel-end]');

      this.bindFilters();
      this.bindMore();
      this.bindNav();
      this.bindOpen();
      this.bindLightbox();
      this.fitEnd();
      if (this.endTile) {
        window.addEventListener('resize', function () {
          window.clearTimeout(this.fitTimer);
          this.fitTimer = window.setTimeout(this.fitEnd.bind(this), 120);
        }.bind(this), { passive: true });
      }

      if (this.autoplay && 'IntersectionObserver' in window) {
        this.io = new IntersectionObserver(this.onIntersect.bind(this), { threshold: [0, 0.3, 0.6, 0.9] });
        this.cards.forEach(function (card) { this.io.observe(card); }.bind(this));
        document.addEventListener('visibilitychange', this.schedule.bind(this));
      } else if (finePointer.matches && motionOK() && !saveData()) {
        this.cards.forEach(function (card) {
          var video = card.querySelector('video');
          card.addEventListener('pointerenter', function () { if (loadVideo(video, false)) safePlay(video); });
          card.addEventListener('pointerleave', function () { video.pause(); });
        });
      }
    }

    onIntersect(entries) {
      entries.forEach(function (entry) {
        this.ratios.set(entry.target, entry.isIntersecting ? entry.intersectionRatio : 0);
      }.bind(this));
      this.schedule();
    }

    schedule() {
      window.clearTimeout(this.scheduleTimer);
      this.scheduleTimer = window.setTimeout(this.apply.bind(this), 140);
    }

    apply() {
      if (!this.autoplay) return;
      var blocked = document.hidden || (this.lightbox && this.lightbox.open);
      var ratios = this.ratios;
      var cards = this.cards;
      var picks = blocked ? [] : cards.filter(function (card) {
        return !card.hidden && (ratios.get(card) || 0) >= 0.6;
      }).sort(function (a, b) {
        return (ratios.get(b) - ratios.get(a)) || (cards.indexOf(a) - cards.indexOf(b));
      }).slice(0, this.maxPlay);
      cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        if (picks.indexOf(card) > -1) {
          video.muted = true;
          if (loadVideo(video, false)) safePlay(video);
        } else if (!video.paused) {
          video.pause();
        }
      });
    }

    visibleCards() {
      return this.cards.filter(function (card) { return !card.hidden; });
    }

    /* Izgarada kapanış kartı son satırdaki boşluğu doldurur */
    fitEnd() {
      var end = this.endTile;
      if (!end || !this.list) return;
      var style = window.getComputedStyle(this.list);
      if (style.display !== 'grid') {
        end.style.removeProperty('grid-column');
        end.removeAttribute('data-span');
        return;
      }
      var cols = style.gridTemplateColumns.split(' ').filter(function (v) { return v && v !== 'none'; }).length || 1;
      var rest = this.visibleCards().length % cols;
      var span = rest === 0 ? cols : cols - rest;
      end.style.gridColumn = 'span ' + span;
      end.setAttribute('data-span', span === cols ? 'full' : String(span));
    }

    bindMore() {
      var self = this;
      var more = this.querySelector('[data-reel-more]');
      if (!more) return;
      more.addEventListener('click', function () { self.expand(); });
    }

    expand() {
      if (!this.classList.contains('is-limited') || this.classList.contains('is-expanded')) return;
      this.classList.add('is-expanded');
      var more = this.querySelector('[data-reel-more]');
      if (more && more.parentElement) more.parentElement.hidden = true;
      this.fitEnd();
      this.schedule();
    }

    bindFilters() {
      var self = this;
      this.filters.forEach(function (button) {
        button.addEventListener('click', function () {
          var value = button.dataset.reelFilter;
          if (value !== 'all') self.expand();
          self.filters.forEach(function (b) { b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
          self.classList.add('is-filtering');
          window.setTimeout(function () {
            self.cards.forEach(function (card) {
              card.hidden = value !== 'all' && card.dataset.cat !== value;
              if (card.hidden) {
                var video = card.querySelector('video');
                if (video) video.pause();
              }
            });
            if (self.list) self.list.scrollLeft = 0;
            self.fitEnd();
            self.classList.remove('is-filtering');
            self.updateNav();
            self.schedule();
          }, motionOK() ? 220 : 0);
          track('byteful_reel_filter', { category: value });
        });
      });
    }

    bindNav() {
      if (!this.list) return;
      var self = this;
      function step(direction) {
        var amount = Math.max(260, self.list.clientWidth * 0.8);
        self.list.scrollBy({ left: direction * amount, behavior: motionOK() ? 'smooth' : 'auto' });
      }
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { step(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { step(1); });
      this.list.addEventListener('scroll', function () {
        window.clearTimeout(self.navTimer);
        self.navTimer = window.setTimeout(function () { self.updateNav(); }, 90);
      }, { passive: true });
      window.addEventListener('resize', function () { self.updateNav(); }, { passive: true });
      this.updateNav();
    }

    updateNav() {
      if (!this.list || !this.prevBtn || !this.nextBtn) return;
      var max = this.list.scrollWidth - this.list.clientWidth - 4;
      this.prevBtn.disabled = this.list.scrollLeft <= 4;
      this.nextBtn.disabled = this.list.scrollLeft >= max;
    }

    bindOpen() {
      var self = this;
      this.cards.forEach(function (card) {
        var button = card.querySelector('[data-reel-open]');
        if (!button) return;
        button.addEventListener('click', function () {
          var visible = self.visibleCards();
          self.open(visible.indexOf(card));
        });
      });
    }

    bindLightbox() {
      var box = this.lightbox;
      if (!box) return;
      var self = this;
      this.lbVideo = box.querySelector('[data-lb-video]');
      this.lbBrand = box.querySelector('[data-lb-brand]');
      this.lbCaption = box.querySelector('[data-lb-caption]');
      this.lbCount = box.querySelector('[data-lb-count]');
      box.querySelector('[data-lb-close]').addEventListener('click', function () { box.close(); });
      box.querySelector('[data-lb-prev]').addEventListener('click', function () { self.go(-1); });
      box.querySelector('[data-lb-next]').addEventListener('click', function () { self.go(1); });
      box.addEventListener('click', function (event) {
        if (event.target === box) box.close();
      });
      box.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') { event.preventDefault(); self.go(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); self.go(-1); }
      });
      box.addEventListener('close', function () {
        if (self.lbVideo) {
          self.lbVideo.pause();
          self.lbVideo.removeAttribute('src');
          self.lbVideo.load();
        }
        document.body.classList.remove('bd-locked');
        if (self.lastTrigger) self.lastTrigger.focus({ preventScroll: true });
        self.schedule();
      });
      if (this.lbVideo) {
        this.lbVideo.addEventListener('ended', function () { self.go(1); });
      }
      var startX = 0;
      var startY = 0;
      box.addEventListener('touchstart', function (event) {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      }, { passive: true });
      box.addEventListener('touchend', function (event) {
        var dx = event.changedTouches[0].clientX - startX;
        var dy = event.changedTouches[0].clientY - startY;
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
        else if (dy > 110 && Math.abs(dy) > Math.abs(dx)) box.close();
      }, { passive: true });
    }

    open(index) {
      var box = this.lightbox;
      if (!box || index < 0) return;
      this.cards.forEach(function (card) {
        var video = card.querySelector('video');
        if (video) video.pause();
      });
      this.current = index;
      this.lastTrigger = document.activeElement;
      if (!box.open) {
        if (typeof box.showModal === 'function') box.showModal();
        else box.setAttribute('open', '');
      }
      document.body.classList.add('bd-locked');
      this.show();
    }

    go(direction) {
      var list = this.visibleCards();
      if (!list.length) return;
      this.current = (this.current + direction + list.length) % list.length;
      this.show();
    }

    show() {
      var list = this.visibleCards();
      var card = list[this.current];
      if (!card || !this.lbVideo) return;
      var source = card.querySelector('video');
      var src = source.dataset.srcHd || source.dataset.src;
      if (!src) return;
      this.lbVideo.poster = source.getAttribute('poster') || '';
      this.lbVideo.src = src;
      this.lbVideo.muted = false;
      var volume = parseFloat(source.dataset.volume);
      this.lbVideo.volume = isNaN(volume) ? 1 : Math.min(1, Math.max(0.05, volume / 100));
      safePlay(this.lbVideo);
      if (this.lbBrand) this.lbBrand.textContent = source.dataset.brand || source.dataset.catLabel || '';
      if (this.lbCaption) this.lbCaption.textContent = source.dataset.caption || '';
      if (this.lbCount) this.lbCount.textContent = (this.current + 1) + ' / ' + list.length;
      track('byteful_reel_play', { brand: source.dataset.brand || '', category: card.dataset.cat || '' });
    }
  }

  /* ---------------------------------------------------------------
     Büyüme paneli: göstergeler sayar, grafik çizilir
     --------------------------------------------------------------- */
  var trInt = new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 });
  var trDec1 = new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

  function formatKpi(value, format) {
    if (format === 'currency') return '₺' + trInt.format(value);
    if (format === 'x') return trDec1.format(value) + 'x';
    if (format === 'percent') return '%' + trInt.format(value);
    return trInt.format(value);
  }

  class BdGrowthPanel extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.kpis = Array.prototype.slice.call(this.querySelectorAll('[data-kpi]'));
      if (!motionOK() || !('IntersectionObserver' in window)) {
        this.classList.add('is-live', 'is-instant');
        return;
      }
      this.kpis.forEach(function (el) {
        var target = parseFloat(String(el.dataset.kpi).replace(',', '.'));
        if (!isNaN(target)) el.textContent = formatKpi(0, el.dataset.format);
      });
      this.io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        this.io.disconnect();
        this.classList.add('is-live');
        this.count();
      }.bind(this), { threshold: 0.35 });
      this.io.observe(this);
    }

    count() {
      var start = performance.now();
      var duration = 1800;
      var kpis = this.kpis;
      function tick(now) {
        var t = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - t, 4);
        kpis.forEach(function (el) {
          var target = parseFloat(String(el.dataset.kpi).replace(',', '.'));
          if (isNaN(target)) return;
          el.textContent = formatKpi(target * eased, el.dataset.format);
        });
        if (t < 1) window.requestAnimationFrame(tick);
      }
      window.requestAnimationFrame(tick);
    }
  }

  /* ---------------------------------------------------------------
     Tanıtım filmi: sessiz önizleme, sesli oynatma ve bölümler
     --------------------------------------------------------------- */
  var wide = window.matchMedia('(min-width: 1100px)');
  function fmtTime(sec) {
    var s = Math.max(0, Math.floor(sec || 0));
    var m = Math.floor(s / 60);
    var r = s % 60;
    return (m < 10 ? '0' : '') + m + ':' + (r < 10 ? '0' : '') + r;
  }

  class BdFilm extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.video = this.querySelector('[data-film-video]');
      this.frame = this.querySelector('[data-film-frame]');
      if (!this.video || !this.frame) return;
      this.mode = 'idle';
      this.previewStart = parseFloat(this.dataset.previewStart) || 0;
      this.previewEnd = parseFloat(this.dataset.previewEnd) || 0;
      this.canPreview = this.dataset.preview !== 'false' && autoplayOK();
      this.seekbar = this.querySelector('[data-film-seekbar]');
      this.nowEl = this.querySelector('[data-film-now]');
      this.totalEl = this.querySelector('[data-film-total]');
      this.endEl = this.querySelector('[data-film-end]');
      this.muteBtn = this.querySelector('[data-film-mute]');
      this.toggleBtn = this.querySelector('[data-film-toggle]');
      this.chapters = Array.prototype.slice.call(this.querySelectorAll('[data-film-seek]'));
      this.times = this.chapters.map(function (b) { return parseFloat(b.dataset.filmSeek) || 0; });
      if (small.matches && this.dataset.posterSm) this.video.setAttribute('poster', this.dataset.posterSm);
      if (!this.canPreview) this.classList.add('is-still');

      var self = this;
      var v = this.video;
      var play = this.querySelector('[data-film-play]');
      if (play) play.addEventListener('click', function () { self.playSound(0); });
      this.chapters.forEach(function (b) {
        b.addEventListener('click', function () { self.playSound(parseFloat(b.dataset.filmSeek) || 0); });
      });
      if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () { self.toggle(); });
      if (this.muteBtn) this.muteBtn.addEventListener('click', function () {
        v.muted = !v.muted;
        self.syncMute();
      });
      var full = this.querySelector('[data-film-full]');
      if (full) full.addEventListener('click', function () { self.toggleFull(); });
      var replay = this.querySelector('[data-film-replay]');
      if (replay) replay.addEventListener('click', function () { self.playSound(0); });
      if (this.seekbar) {
        this.seekbar.addEventListener('input', function () {
          var t = parseFloat(self.seekbar.value) || 0;
          if (self.mode !== 'sound') { self.playSound(t); return; }
          try { v.currentTime = t; } catch (error) { /* yok say */ }
          self.paint(t);
        });
      }

      v.addEventListener('loadedmetadata', function () {
        if (self.seekbar && v.duration) self.seekbar.max = v.duration.toFixed(1);
        if (self.totalEl && v.duration) self.totalEl.textContent = fmtTime(v.duration);
      });
      v.addEventListener('loadeddata', function () { self.classList.add('is-loaded'); });
      v.addEventListener('timeupdate', function () {
        if (self.mode === 'sound') {
          self.paint(v.currentTime);
        } else if (self.mode === 'preview' && self.previewEnd > self.previewStart && v.currentTime >= self.previewEnd) {
          try { v.currentTime = self.previewStart; } catch (error) { /* yok say */ }
        }
      });
      v.addEventListener('play', function () { self.classList.add('is-playing'); self.classList.remove('is-paused'); });
      v.addEventListener('pause', function () {
        self.classList.remove('is-playing');
        if (self.mode === 'sound' && !v.ended) self.classList.add('is-paused');
      });
      v.addEventListener('ended', function () { if (self.mode === 'sound') self.onEnded(); });

      this.frame.addEventListener('click', function (event) {
        if (event.target.closest('button, a, input, [data-film-end]')) return;
        if (self.mode !== 'sound') { self.playSound(0); return; }
        self.toggle();
      });
      this.frame.addEventListener('pointermove', function () { self.wake(); }, { passive: true });
      this.frame.addEventListener('pointerdown', function () { self.wake(); }, { passive: true });
      this.addEventListener('focusin', function () { self.wake(); });
      this.addEventListener('keydown', function (event) {
        if (self.mode !== 'sound') return;
        var tag = event.target.tagName;
        var key = event.key;
        if (key === 'k' || (key === ' ' && tag !== 'BUTTON' && tag !== 'A' && tag !== 'INPUT')) {
          event.preventDefault();
          self.toggle();
        } else if (key === 'm') {
          v.muted = !v.muted;
          self.syncMute();
        } else if (key === 'f') {
          self.toggleFull();
        } else if ((key === 'ArrowRight' || key === 'ArrowLeft') && tag !== 'INPUT') {
          event.preventDefault();
          try { v.currentTime = Math.max(0, v.currentTime + (key === 'ArrowRight' ? 5 : -5)); } catch (error) { /* yok say */ }
        }
      });

      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          self.visible = entries[0].isIntersecting;
          if (self.visible && !document.hidden) {
            if (self.mode !== 'sound') self.startPreview();
          } else if (!v.paused) {
            v.pause();
          }
        }, { threshold: 0.35 });
        this.io.observe(this.frame);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.hidden && !v.paused) v.pause();
        else if (!document.hidden && self.visible && self.mode === 'preview') safePlay(v);
      });
      this.syncMute();
    }

    source(kind) {
      var d = this.dataset;
      if (kind === 'preview') return small.matches ? (d.srcLow || d.srcSd || d.srcHd) : (d.srcSd || d.srcLow || d.srcHd);
      return wide.matches && !saveData() ? (d.srcHd || d.srcSd || d.srcLow) : (d.srcSd || d.srcHd || d.srcLow);
    }

    load(src, t) {
      var v = this.video;
      if (!src) return false;
      if (v.dataset.loaded !== src) {
        v.src = src;
        v.dataset.loaded = src;
        if (t) {
          var onMeta = function () {
            v.removeEventListener('loadedmetadata', onMeta);
            try { v.currentTime = t; } catch (error) { /* yok say */ }
          };
          v.addEventListener('loadedmetadata', onMeta);
        }
      } else if (t !== null && t !== undefined) {
        try { v.currentTime = t; } catch (error) { /* yok say */ }
      }
      return true;
    }

    startPreview() {
      if (!this.canPreview || this.mode === 'sound') return;
      var v = this.video;
      v.muted = true;
      v.loop = true;
      var first = this.mode !== 'preview';
      this.mode = 'preview';
      this.classList.add('is-preview');
      if (!this.load(this.source('preview'), first && v.dataset.loaded !== this.source('preview') ? this.previewStart : null)) return;
      safePlay(v);
    }

    playSound(t) {
      var v = this.video;
      var self = this;
      var start = Math.max(0, t || 0);
      this.mode = 'sound';
      this.classList.remove('is-preview', 'is-ended', 'is-still');
      this.classList.add('is-sound');
      if (this.endEl) this.endEl.hidden = true;
      v.loop = false;
      v.muted = false;
      v.volume = 1;
      this.load(this.source('sound'), start);
      this.paint(start);
      var promise;
      try { promise = v.play(); } catch (error) { promise = null; }
      if (promise && typeof promise.catch === 'function') {
        promise.catch(function () {
          v.muted = true;
          self.syncMute();
          safePlay(v);
        });
      }
      this.syncMute();
      this.wake();
      if (small.matches && !(document.fullscreenElement || document.webkitFullscreenElement)) this.enterFull();
      track('bd_film_play', { start: Math.round(start) });
    }

    toggle() {
      var v = this.video;
      if (this.mode !== 'sound') { this.playSound(0); return; }
      if (v.paused) safePlay(v);
      else v.pause();
      this.wake();
    }

    onEnded() {
      this.classList.add('is-ended');
      this.classList.remove('is-paused');
      if (this.endEl) this.endEl.hidden = false;
      var fs = document.fullscreenElement || document.webkitFullscreenElement;
      if (fs && fs === this.frame) {
        var exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (exit) exit.call(document);
      }
      track('bd_film_complete', {});
    }

    toggleFull() {
      var fs = document.fullscreenElement || document.webkitFullscreenElement;
      if (fs) {
        var exit = document.exitFullscreen || document.webkitExitFullscreen;
        if (exit) exit.call(document);
        return;
      }
      this.enterFull();
    }

    enterFull() {
      var el = this.frame;
      var lock = function () {
        try {
          if (screen.orientation && typeof screen.orientation.lock === 'function') {
            var q = screen.orientation.lock('landscape');
            if (q && typeof q.catch === 'function') q.catch(function () {});
          }
        } catch (error) { /* desteklenmiyor */ }
      };
      if (el.requestFullscreen) {
        var p = el.requestFullscreen();
        if (p && typeof p.then === 'function') p.then(lock, function () {});
      } else if (el.webkitRequestFullscreen) {
        el.webkitRequestFullscreen();
      } else if (this.video.webkitEnterFullscreen) {
        try { this.video.webkitEnterFullscreen(); } catch (error) { /* yok say */ }
      }
    }

    syncMute() {
      var muted = this.video.muted;
      this.classList.toggle('is-muted', muted);
      if (this.muteBtn) this.muteBtn.setAttribute('aria-label', muted ? 'Sesi aç' : 'Sesi kapat');
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', this.video.paused ? 'Oynat' : 'Duraklat');
    }

    wake() {
      var self = this;
      this.classList.add('is-ui');
      window.clearTimeout(this.uiTimer);
      this.uiTimer = window.setTimeout(function () {
        if (!self.video.paused) self.classList.remove('is-ui');
      }, 2600);
      if (this.toggleBtn) this.toggleBtn.setAttribute('aria-label', this.video.paused ? 'Oynat' : 'Duraklat');
    }

    paint(t) {
      var v = this.video;
      var dur = v.duration || parseFloat(this.seekbar && this.seekbar.max) || 60;
      if (this.seekbar) {
        this.seekbar.value = t;
        this.seekbar.style.setProperty('--p', Math.min(1, t / dur).toFixed(4));
      }
      if (this.nowEl) this.nowEl.textContent = fmtTime(t);
      var active = -1;
      for (var i = 0; i < this.times.length; i++) if (t >= this.times[i] - 0.05) active = i;
      var times = this.times;
      this.chapters.forEach(function (b, n) {
        var on = n === active;
        if (on) b.setAttribute('aria-current', 'true');
        else b.removeAttribute('aria-current');
        var from = times[n];
        var to = n + 1 < times.length ? times[n + 1] : dur;
        var p = t <= from ? 0 : t >= to ? 1 : (t - from) / Math.max(0.1, to - from);
        b.style.setProperty('--cp', p.toFixed(3));
      });
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('[data-film-open]');
    if (!trigger) return;
    var film = document.querySelector('bd-film');
    if (!film || typeof film.playSound !== 'function') return;
    event.preventDefault();
    film.scrollIntoView({ behavior: motionOK() ? 'smooth' : 'auto', block: 'center' });
    film.playSound(0);
  });

  define('bd-phone-feed', BdPhoneFeed);
  define('bd-notify-stack', BdNotifyStack);
  define('bd-reels', BdReels);
  define('bd-growth-panel', BdGrowthPanel);
  define('bd-film', BdFilm);

  /* Açılış başlığını kelimelere böler, kelimeler sırayla belirir */
  function splitWords(el) {
    if (!el || el.classList.contains('is-split')) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    var index = 0;
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) {
          frag.appendChild(document.createTextNode(part));
          return;
        }
        var word = document.createElement('span');
        word.className = 'bd-w';
        word.textContent = part;
        word.style.setProperty('--wi', index);
        index += 1;
        frag.appendChild(word);
      });
      node.parentNode.replaceChild(frag, node);
    });
    el.classList.add('is-split');
  }

  function init() {
    initMagnetic(document);
    if (motionOK() && !document.body.classList.contains('bd-design-mode')) {
      Array.prototype.forEach.call(document.querySelectorAll('.bd-hero__title[data-split]'), splitWords);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    initMagnetic(event.target);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest && event.target.closest('.bd-reel');
    if (card && card.parentElement) {
      card.parentElement.scrollTo({ left: card.offsetLeft - 20, behavior: 'smooth' });
    }
  });
})();
